import { useContext, useState } from "react";

import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import Header from "./Header";
import Home from "./Home";
import NoMatch from "./NoMatch";
import SingleProject from "./Home/Project/SingleProject";
import GlobalStyle from "./GlobalStyles";
import { ThemeContext } from "./Context/ThemeContext";
import * as React from "react";

const App = () => {
  const { theme, path } = useContext(ThemeContext);

  // console.log(path === "/" || path.includes("/project/"));
  return (
    <>
      <GlobalStyle theme={theme} />
      <Router>
        {(path === "/" || path.includes("/project/")) && <Header />}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project/:id" element={<SingleProject />} />
          <Route path="*" element={<NoMatch />} />
        </Routes>
      </Router>
    </>
  );
};

export default App;
